import { VideoTitleParams } from 'js/src/client';

export const trackUpsellClicked = (context: string, params: { [key: string]: unknown } = {}) => {
    analytics.track('upsell_clicked', {
        context,
        ...{ params },
    });
    analytics.trackHSEvent('upsell_clicked', {
        lumen5_upsell_click_context: context,
        lumen5_upsell_click_date: new Date().getTime(),
        lumen5_plan_name: SERVER.ANALYTICS?.plan_name,
        lumen5_video_count: SERVER.ANALYTICS?.video_count,
    });
};

export const trackVideoNameExceedsCharLimit = (numChars: number, videoId: number | null) => {
    analytics.track('Video Title Exceeds Limit in creator', {
        video_id: videoId,
        character_limit: VideoTitleParams.MAX_LENGTH,
        number_of_characters: numChars,
    });
};
